import { ArrowLeftRounded, ArrowRightRounded } from '@material-ui/icons'
import cx from 'clsx'
import Carousel from 'react-material-ui-carousel'

import { AnswerCarousel } from '@karakuri-web/faq-type'

import { SkillApi } from './interface'
import { renderAnswer } from './renderAnswer'

export function renderCarousel(
  index: number,
  carousel: AnswerCarousel,
  skillApi: SkillApi,
  cardId: string,
  onChange: (now?: number, prev?: number) => void
) {
  if (!carousel.contents) return null

  const changePage = (now?: number, prev?: number) => {
    onChange(now, prev)
  }

  const carouselPages = carousel.contents.map(content => {
    return (
      <div
        key={`carousel-${cardId}-${carousel.id}-${content.id}`}
        className={cx('faq-answer-content__carousel-slide')}
      >
        {renderAnswer(content, skillApi, cardId)}
      </div>
    )
  })

  return (
    <>
      {carouselPages && (
        <Carousel
          index={index}
          swipe={true}
          NextIcon={<ArrowRightRounded />}
          PrevIcon={<ArrowLeftRounded />}
          navButtonsAlwaysVisible={true}
          indicatorIconButtonProps={{
            className: cx('faq-answer-content__carousel-indicator-button'),
          }}
          navButtonsProps={{
            className: cx('faq-answer-content__carousel-nav-button'),
          }}
          autoPlay={false}
          animation={'slide'}
          onChange={changePage}
        >
          {carouselPages}
        </Carousel>
      )}
    </>
  )
}
